import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import { Mic, Users, Award, Calendar } from "lucide-react";

function TextGrid() {
  let pageHeader = React.createRef();
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      {events.map((e, eventIndex) => (
        <div
          key={eventIndex}
          style={{
            backgroundColor: "#000",
            padding: size ? "4rem 0" : "2rem 0",
          }}
          className="section"
          data-parallax={true}
          ref={pageHeader}
        >
          <Container>
            {/* Logo and Location Section */}
            <Row className="justify-content-center mb-5">
              <Col md={12}>
                <div className="container-fluid row justify-content-center align-items-center">
                  <Col lg={6} xs={12} className={`${!size && "text-center pb-4"}`}>
                    <div
                      style={{
                        background: "#ffffff",
                        borderRadius: "20px",
                        padding: size ? "2rem" : "1.5rem",
                        display: "inline-block",
                        width: "100%",
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      <img
                        src={e.logo}
                        style={{
                          maxWidth: size ? "450px" : "250px",
                          width: "100%",
                        }}
                        alt="event logo"
                      />
                    </div>
                  </Col>
                  <Col lg={6} xs={12} className="align-self-center">
                    <div
                      style={{
                        borderLeft: size ? "3px solid #ffb41f" : "none",
                        borderTop: !size ? "3px solid #ffb41f" : "none",
                        paddingLeft: size ? "2rem" : "0",
                        paddingTop: !size ? "1.5rem" : "0",
                        marginTop: !size ? "1.5rem" : "0",
                      }}
                    >
                      <h3
                        className="text-white mb-0"
                        style={{
                          fontSize: size ? "2rem" : "1.5rem",
                          fontWeight: "600",
                          lineHeight: "1.5",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {e.location}
                        <br />
                        <span
                          style={{
                            color: "#ffb41f",
                            fontSize: size ? "1.5rem" : "1.2rem",
                            fontWeight: "400",
                          }}
                        >
                          {e.date}
                        </span>
                      </h3>
                    </div>
                  </Col>
                </div>
              </Col>
            </Row>

            {/* Stats and Charts Section */}
            <Row className="justify-content-center">
              {/* Stats Cards */}
              <Col lg={4} xs={12} className="mb-4">
                <div className="container-fluid row">
                  {e.stats.map((c, statIndex) => (
                    <Col lg={6} xs={6} className="mb-3" key={statIndex}>
                      <Card
                        style={{
                          background: "rgba(255, 255, 255, 0.05)",
                          backdropFilter: "blur(10px)",
                          border: "1px solid rgba(255, 180, 31, 0.2)",
                          borderRadius: "16px",
                          padding: size ? "1.5rem 1rem" : "1rem 0.75rem",
                          height: "100%",
                          transition: "all 0.3s ease",
                          textAlign: "center",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = "rgba(255, 180, 31, 0.15)";
                          e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.5)";
                          e.currentTarget.style.transform = "translateY(-5px)";
                          e.currentTarget.style.boxShadow = "0 10px 25px rgba(255, 180, 31, 0.3)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "rgba(255, 255, 255, 0.05)";
                          e.currentTarget.style.borderColor = "rgba(255, 180, 31, 0.2)";
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <div
                          style={{
                            width: size ? "80px" : "70px",
                            height: size ? "80px" : "70px",
                            background: "linear-gradient(135deg, rgba(255, 180, 31, 0.2), rgba(204, 182, 58, 0.15))",
                            borderRadius: "50%",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            border: "2px solid rgba(255, 180, 31, 0.3)",
                            margin: "0 auto 0.75rem",
                            boxShadow: "0 4px 15px rgba(255, 180, 31, 0.2), inset 0 0 20px rgba(255, 180, 31, 0.1)",
                          }}
                        >
                          {React.createElement(c.icon, {
                            size: size ? 40 : 35,
                            strokeWidth: 2.5,
                            style: {
                              color: "#ffb41f",
                              filter: "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.3))",
                            },
                          })}
                        </div>
                        <h4
                          className="text-white mb-2"
                          style={{
                            fontSize: size ? "2rem" : "1.75rem",
                            fontWeight: "700",
                            color: "#ffb41f",
                            lineHeight: "1.2",
                          }}
                        >
                          {c.value}
                        </h4>
                        <p
                          className="text-white mb-0"
                          style={{
                            fontSize: size ? "14px" : "12px",
                            fontWeight: "500",
                            lineHeight: "1.4",
                            letterSpacing: "0.3px",
                          }}
                        >
                          {c.title}
                        </p>
                      </Card>
                    </Col>
                  ))}
                </div>
              </Col>

              {/* Pie Chart */}
              <Col lg={4} xs={12} className={`${!size && "text-center mb-4"}`}>
                <Card
                  style={{
                    background: "rgba(255, 255, 255, 0.05)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 180, 31, 0.2)",
                    borderRadius: "16px",
                    padding: size ? "2rem" : "1.5rem",
                    textAlign: "center",
                  }}
                >
                  <img
                    src={e.piechart}
                    style={{
                      maxWidth: size ? "350px" : "250px",
                      width: "100%",
                      filter: "drop-shadow(0 4px 8px rgba(255, 180, 31, 0.2))",
                    }}
                    alt="pie chart"
                  />
                </Card>
              </Col>

              {/* Profile Breakdown */}
              <Col lg={4} xs={12}>
                <Card
                  style={{
                    background: "rgba(255, 255, 255, 0.05)",
                    backdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 180, 31, 0.2)",
                    borderRadius: "16px",
                    padding: size ? "2rem" : "1.5rem",
                    height: "100%",
                  }}
                >
                  <h5
                    className="text-white mb-4"
                    style={{
                      fontSize: size ? "1.25rem" : "1.1rem",
                      fontWeight: "600",
                      color: "#ffb41f",
                      textAlign: "center",
                    }}
                  >
                    ATTENDEE PROFILE
                  </h5>
                  {e.profiles.map((p, profileIndex) => (
                    <div
                      key={profileIndex}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "0.75rem",
                        padding: "0.5rem",
                        borderRadius: "8px",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = "rgba(255, 180, 31, 0.1)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = "transparent";
                      }}
                    >
                      <div
                        style={{
                          width: size ? "12px" : "10px",
                          height: size ? "12px" : "10px",
                          borderRadius: "50%",
                          backgroundColor: p.color,
                          flexShrink: 0,
                          marginRight: "0.75rem",
                        }}
                      />
                      <div style={{ flex: 1 }}>
                        <h6
                          className="text-white mb-0"
                          style={{
                            fontSize: size ? "15px" : "13px",
                            fontWeight: "500",
                            lineHeight: "1.4",
                          }}
                        >
                          {p.title}
                        </h6>
                      </div>
                      <span
                        className="text-white"
                        style={{
                          fontSize: size ? "15px" : "13px",
                          fontWeight: "600",
                          color: "#ffb41f",
                        }}
                      >
                        {p.value}
                      </span>
                    </div>
                  ))}
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      ))}
    </>
  );
}

export default TextGrid;

const events = [
  {
    logo: require("assets/pastevent/me.png"),
    location: "HABTOOR PALACE, DUBAI UAE",
    date: "MARCH 20-21, 2024",
    stats: [
      { title: "SPEAKERS", value: 35, icon: Mic },
      { title: "ATTENDEES", value: 282, icon: Users },
      { title: "EXHIBITORS", value: 12, icon: Award },
      { title: "WORKSHOP DELEGATES", value: 21, icon: Calendar },
    ],
    piechart: require("assets/icons/3piechart.png"),
    profiles: [
      { title: "ENGINEERING", value: "14.5%", color: "#3E8BA4" },
      { title: "CONSULTANTS", value: "21.1%", color: "#6A6C98" },
      { title: "SOFTWARE PROVIDERS", value: "27.5%", color: "#5F9696" },
      { title: "DEVELOPERS", value: "10%", color: "#858688" },
      { title: "PROJECT OWNERS", value: "9.4%", color: "#384881" },
      { title: "ARCHITECTURE", value: "6.6%", color: "#50467B" },
      { title: "CONTRACTOR", value: "7.3%", color: "#5990B5" },
      { title: "FM", value: "2.4%", color: "#5990B5" },
    ],
  },

  {
    logo: require("assets/pastevent/ksa.png"),
    location: "RIYADH AIRPORT MARRIOTT HOTEL, RIYADH, KSA",
    date: "OCTOBER 8-9, 2024",
    stats: [
      { title: "SPEAKERS", value: 34, icon: Mic },
      { title: "ATTENDEES", value: 365, icon: Users },
      { title: "EXHIBITORS", value: 14, icon: Award },
      { title: "WORKSHOP DELEGATES", value: 81, icon: Calendar },
    ],
    piechart: require("assets/icons/2piechart.png"),
    profiles: [
      { title: "CONSULTANT ", value: "15.5%", color: "#4F8436" },
      { title: "ENGINEERING ", value: "7.4%", color: "#6B9890" },
      { title: "CONTRACTOR", value: "19.2%", color: "#78A342" },
      { title: "DEVELOPERS", value: "19.2%", color: "#9E9B3C" },
      { title: "PROJECT OWNERS", value: "28.2%", color: "#377B3C" },
      { title: "SOFTWARE PROVIDER", value: "3.8%", color: "#9E9B3C" },
      { title: "ARCHITECTURE", value: "3.1%", color: "#94BEA9" },
      { title: "FM ", value: "2.6%", color: "#49A2C0" },
    ],
  },
  {
    logo: require("assets/pastevent/uk.png"),
    location: "ONE GREAT GEORGE STREET LONDON, UK",
    date: "OCTOBER 30-31, 2024",
    stats: [
      { title: "SPEAKERS", value: 40, icon: Mic },
      { title: "ATTENDEES", value: 155, icon: Users },
      { title: "EXHIBITORS", value: 5, icon: Award },
      { title: "WORKSHOP DELEGATES", value: 37, icon: Calendar },
    ],
    piechart: require("assets/icons/1piechart.png"),
    profiles: [
      { title: "CONSULTANT", value: "33.3%", color: "#362D6F" },
      { title: "ENGINEERING", value: "10.2%", color: "#42467B" },
      { title: "DEVELOPER", value: "5.4%", color: "#789FA8" },
      { title: "CONTRACTOR", value: "8.2%", color: "#AA7C95" },
      { title: "PROJECT OWNER ", value: "8.2%", color: "#AA7C95" },
      { title: "SOFTWARE PROVIDER", value: "25.9%", color: "#212961" },
      { title: "ARCHITECTURE", value: "7.5%", color: "#896C92" },
      { title: "FM", value: "1.4%", color: "#594A86" },
    ],
  },
];
